import React from "react";
import style from "./imageuploader.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";


function ImageUploader({handleImageUpload, multiplePreview, setMultiplePreview, handleCancel}) {

const handleImageChange = async (e) => {
  const files = Array.from(e.target.files || []);
  if (!files.length) return;

  try {
    const previews = [];
    await Promise.all(
      files.map(async (file) => {
        try {
          const url = URL.createObjectURL(file);
          previews.push(url);
          handleImageUpload(file, url)
        } catch (uploadErr) {
          console.error("handleImageUpload error:", uploadErr);
        }
      })
    );
    setMultiplePreview([...multiplePreview, ...previews]);
  } catch (err) {
    console.error('Image upload failed:', err);
  }
};



  const handleRemove = (del) => {
    handleCancel(del)
    const filter = multiplePreview.filter((e)=> e !== del)
    setMultiplePreview(filter)
  }

  return (
    <div className={style.uploadWrapper}>
    <label htmlFor="media"> Gallery</label>
      <input
        type="file"
        id="media"
        accept="image/*"
        multiple
        onChange={handleImageChange}
        style={{ marginBottom: "1rem" }}
        className={style.input}
      />
      <div className={style.fleximg}>
        <div className={style.preview}>
          {multiplePreview && (
            multiplePreview.map((e)=>(
              <div key={e} className={style.imageWrap}>
                <img
                  src={e}
                  alt="Preview"
                  style={{ width: "200px", borderRadius: "8px", border: "1px solid #ccc" }}
                />
                <span className={style.icon}>
                  <FontAwesomeIcon icon={faTimes} onClick={()=>handleRemove(e)}/>
                </span>
              </div>
              ))
          )}
        </div>
        {multiplePreview.length === 0 ? 
        <label htmlFor="media">Browse</label> : 
        <label htmlFor="media" className={style.add}>
          <FontAwesomeIcon icon={faPlus}/>
        </label>
        }
      </div>
    </div>
  );
}

export default ImageUploader;
